export const TransactionManagerCy = {
    ButtonSubmit: 'tm-submit',
    ButtonCancel: 'tm-cancel',
    ButtonShowMoreIndexed: 'tm-show-more',
    ButtonAddLineIndexed: 'tm-add-line',
    ButtonDuplicateLineIndexed: 'tm-duplicate-line',
    ButtonDeleteLineIndexed: 'tm-delete-line',
    Root: 'tm-root',
}